// Group schema (spec §5)
// A named, user-facing set of graph/diagram elements. On import, one group is
// auto-created per connected component of the drawn graph ("Group 1..N").
// Editable later (rename, recolor, show/hide, merge/split); membership is by
// element id. Flat — no nesting in v1. Decoupled from the solver.
//
// A Group is a DISPLAY set, not a solve unit. The solver's Systems are named
// "System 1..N" and partitioned from calculation connectivity; a closed valve
// splits a System but not a Group, so the two never reliably correspond. These
// were themselves named "System 1..N" until 2026-08-27; renamed so one Model
// cannot show two different things called "System 1".

import { z } from 'zod';
import { RgbaSchema } from '../base/common';

export const GroupSchema = z.object({
  id: z.string(),
  name: z.string(),
  /** Optional tint + legend entry. Unset → no tint. */
  color: RgbaSchema.optional(),
  /** Show/hide. */
  visibility: z.boolean().default(true),
  /** Member element ids (vertices, edges, and — later — diagram elements). */
  member_ids: z.array(z.string()).default([]),
});

export type Group = z.infer<typeof GroupSchema>;
